import { useEffect, useRef } from "react";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaXTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa6"; // X (Twitter)

// Import your images (replace with your actual image paths)
// import binStatus from "../assets/bin-status.png";
import card1 from "../assets/images-webp/aiajv.webp";
import card2 from "../assets/images-webp/doortodoor.webp";
import card3 from "../assets/images-webp/weigh.webp";
import card4 from "../assets/images-webp/bin1.webp";
import card5 from "../assets/images-webp/vehicle.webp";
import card6 from "../assets/images-webp/emp.webp";
import vishal from "../assets/images-webp/vishal.webp";
import bghero from "../assets/images-webp/herobg.webp";
import bgvideo from "../assets/video/v1.mp4";
import faq from "../assets/images-webp/faq.webp";
import bin from "../assets/images-webp/blog1.webp";
import AIRecycling from "../assets/images-webp/blog2.webp";
import Policy from "../assets/images-webp/blog3.webp";
import trackWasteDigital from "../assets/images-webp/blog4digitalwaste.webp";
import wasteSorting from "../assets/images-webp/wasteSorting.webp";
import lottie from "lottie-web";
import {
  FaMapMarkedAlt,
  FaRecycle,
  FaUsersCog,
  FaChartBar,
  FaTrashAlt,
  FaRoute,
} from "react-icons/fa";
import Footer from "./Footer";
import SocialMediaSidebar from "./SocialMediaSidebar";
import ScrollToTopButton from "./ScrollToTopButton";

export default function Home() {
  const lottieRef = useRef(null);
  const navigate = useNavigate();
  const [is1366x768, setIs1366x768] = useState(false);

  // Resolution check effect
  useEffect(() => {
    const checkResolution = () => {
      setIs1366x768(window.innerWidth === 1366 && window.innerHeight >= 300);
    };

    checkResolution();
    window.addEventListener("resize", checkResolution);
    return () => window.removeEventListener("resize", checkResolution);
  }, []);

  const routePaths = [
    "/geo-tracking",
    "/smart-segregation",
    "/grievance-redressal",
    "/data-insights",
    "/route-optimization",
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true, // Enables autoplay
    autoplaySpeed: 2000, // Delay between slides in milliseconds (1000ms = 1 second)
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: lottieRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/01_Homepage.json", // Make sure this path is correct
    });

    return () => anim.destroy(); // Clean up on unmount
  }, []);

  // console.log("is1366x768:", is1366x768);

  const blogPosts = [
    {
      img: Policy,
      tag: "Sustainability",
      title: "Policy Changes Shaping Waste Management",
      desc: "An in-depth overview of recent policy reforms and government regulations in India and across the globe that are driving the shift toward smarter, more sustainable waste management. These policies emphasize the integration of digital technologies and IoT to enhance efficiency, transparency, and environmental impact.",
      authorImg: vishal,
      author: "Admin",
      date: "June 9, 2025",
    },
    {
      img: bin,
      tag: "Smart Bins",
      title: "How IoT is Revolutionizing Waste Collection",
      desc: "Cities around the world are adopting IoT-enabled smart bins and sensor-based systems that monitor waste levels in real time, optimize collection routes, reduce operational costs, and minimize environmental impact. This technology-driven approach is transforming traditional waste collection into an efficient, data-informed service.",
      authorImg: vishal,
      author: "Admin",
      date: "June 9, 2025",
    },
    {
      img: AIRecycling,
      tag: "AI & Recycling",
      title: "AI-Powered Waste Segregation Explained",
      desc: "Discover how artificial intelligence is transforming waste segregation by automating the identification and sorting of materials at the source. Through advanced image recognition, machine learning, and robotics, AI is helping increase recycling rates, reduce contamination, and streamline waste processing systems.",
      authorImg: vishal,
      author: "Admin",
      date: "June 9, 2025",
    },
    {
      img: trackWasteDigital,
      tag: "Digital Tracking",
      title: "Tracking Waste Digitally",
      desc: "Digital technologies are revolutionizing waste management by enabling real-time tracking of waste generation, movement, and disposal. From RFID tags to GPS-enabled vehicles and cloud-based dashboards, these tools enhance transparency, improve accountability, and streamline logistics for greater operational efficiency.",
      authorImg: vishal,
      author: "Admin",
      date: "June 9, 2025",
    },
    {
      img: wasteSorting,
      tag: "Automation",
      title: "Automation in Waste Sorting",
      desc: "Automation technologies such as conveyor-based sorters, robotic arms, and AI-powered vision systems are making waste sorting faster, more accurate, and safer. These innovations reduce manual labor, improve material recovery rates, and contribute to more efficient and sustainable waste processing operations.",
      authorImg: vishal,
      author: "Admin",
      date: "June 9, 2025",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    className: "custom-dots-slider",
    autoplay: true,
    autoplaySpeed: 2000,
    rtl: true, // <-- Reverses auto slide direction
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const visiblePosts = blogPosts; // always show all

  const slugify = (text) =>
    text
      .toLowerCase()
      .replace(/[^\w ]+/g, "")
      .replace(/ +/g, "-");

  const truncateWords = (text, maxWords) => {
    if (!text) return ""; // Handle null/undefined
    const words = text.split(/\s+/).filter((word) => word.length > 0);
    return words.length > maxWords
      ? `${words.slice(0, maxWords).join(" ")}...`
      : text;
  };

  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <div>
        <ScrollToTopButton />
      </div>
      {/* Hero Section - Conditionally Rendered */}
      {is1366x768 ? (
        // 1366×768 Layout
        <div className="relative w-full min-h-[368px] overflow-hidden bg-gray-900">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover z-0 opacity-[0.5]"
          >
            <source src={bgvideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <div className="relative z-10 flex flex-col items-center justify-between h-full px-4 pt-12 pb-8 text-white sm:px-6 lg:px-8">
            <div className="flex flex-col mt-7 md:flex-row items-center justify-center gap-6 md:gap-12 w-full">
              <div className="w-full md:w-1/2 max-w-md">
                <div
                  ref={lottieRef}
                  className="w-full h-[320px] rounded-lg"
                ></div>
              </div>

              <div className="text-center md:text-left max-w-xl mt-0 md:-mt-8">
                <h1 className="text-3xl sm:text-4xl font-extrabold leading-tight">
                  SWACHH-AJV PREFERRED AI-ENABLED WASTE SOLUTION OEM
                </h1>
                <p className="mt-3 text-lg sm:text-xl text-gray-100 font-bold">
                  Smart Waste Solutions for a Cleaner Tomorrow
                </p>
              </div>
            </div>

            <div className="w-full max-w-5xl px-4 mt-6 md:mt-8">
              <Slider {...sliderSettings} className="custom-slider-1366">
                {[
                  { img: card1, title: "AIaaS enabled Waste" },
                  { img: card2, title: "Door-to-Door" },
                  { img: card3, title: "Weighbridge" },
                  { img: card4, title: "Bin Monitoring" },
                  { img: card5, title: "Vehicle Tracking" },
                  { img: card6, title: "Employee Management" },
                ].map((card, i) => (
                  <div key={i} className="px-2">
                    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition duration-300 h-full">
                      <img
                        src={card.img}
                        alt={card.title}
                        className="w-full h-32 object-cover border-b-2 border-black"
                      />
                      <div className="p-2 text-center text-xl font-bold text-gray-900">
                        {card.title}
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          <style>{`
            @media (max-width: 1366px) {
              .custom-slider-1366 .slick-slide {
                padding: 0 8px;
              }
              .custom-slider-1366 .slick-list {
                margin: 0 -8px;
              }
            }
          `}</style>
        </div>
      ) : (
        // Default Layout
        <div className="relative w-full h-full overflow-hidden bg-gray-900">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover z-0 opacity-[0.5]"
          >
            <source src={bgvideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 pt-20 text-white sm:px-6 lg:px-8">
            <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-20">
              <div className="w-full md:w-1/2 max-w-md">
                <div
                  ref={lottieRef}
                  className="w-full h-[410px] rounded-lg"
                ></div>
              </div>

              <div className="text-center md:text-left max-w-xl -mt-24 md:mt-0">
                <h1 className="text-4xl sm:text-3xl font-extrabold leading-tight">
                  SWACHH-AJV PREFERRED AI-ENABLED WASTE SOLUTION OEM
                </h1>
                <p className="mt-4 text-xl text-gray-100 font-bold">
                  Smart Waste Solutions for a Cleaner Tomorrow
                </p>
              </div>
            </div>

            <div className="w-full max-w-6xl px-4">
              <Slider {...sliderSettings}>
                {[
                  { img: card1, title: "AIaaS enabled Waste" },
                  { img: card2, title: "Door-to-Door" },
                  { img: card3, title: "Weighbridge" },
                  { img: card4, title: "Bin Monitoring" },
                  { img: card5, title: "Vehicle Tracking" },
                  { img: card6, title: "Employee Management" },
                ].map((card, i) => (
                  <div key={i} className="px-2">
                    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition duration-300 h-full">
                      <img
                        src={card.img}
                        alt={card.title}
                        className="w-full h-40 object-cover border-b-2 border-black"
                      />
                      <div className="p-2 text-center text-2xl font-bold text-gray-900">
                        {card.title}
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      )}

      {/* Vision & Mission Section */}
      <div className="w-full flex flex-col items-center mt-8 px-4 sm:px-6 lg:px-20">
        {/* Heading */}
        <h2 className="text-3xl sm:text-4xl md:text-4xl font-bold text-[#00D084] mb-6 text-center">
          Vision & Mission
        </h2>

        {/* Card Container */}
        <div className="bg-white shadow-2xl border rounded-2xl p-6 sm:p-10 max-w-6xl w-full flex flex-col md:flex-row items-center gap-8 sm:gap-12">
          {/* Profile Image */}
          <div className="flex-shrink-0 mb-6 md:mb-0">
            <img
              src={vishal}
              alt="Vishal Gupta"
              className="w-40 h-40 sm:w-52 sm:h-52 md:w-64 md:h-64 object-cover rounded-full border-4 border-white shadow-lg"
            />
          </div>

          {/* Text Content */}
          <div className="text-center md:text-left">
            <p className="text-lg sm:text-xl md:text-2xl text-gray-800 leading-relaxed mb-4">
              <span className="text-[#00D084] text-3xl sm:text-4xl font-bold mr-2">
                “
              </span>
              Empowering a smarter tomorrow through connected infrastructure and
              AI-driven insights, backed by deep expertise, innovation, and a
              commitment to excellence.
              <span className="text-[#00D084] text-3xl sm:text-4xl font-bold ml-2">
                ”
              </span>
            </p>
            <p className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">
              Vishal Gupta
            </p>
            <p className="text-sm sm:text-base md:text-lg text-[#00D084] font-semibold">
              Founder & Director | AJEEVI
            </p>
          </div>
        </div>
      </div>

      {/* Our Offerings */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-16 bg-white text-center font-poppins">
        {/* Heading */}
        <h2 className="text-3xl sm:text-4xl lg:text-4xl font-bold text-[#00D084] mb-4">
          Our Offerings
        </h2>
        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-2">
          Empowering Cities Through{" "}
          <span className="text-black font-extrabold">
            AI-Centric Waste Solutions
          </span>
        </h3>
        <p className="text-black text-base sm:text-lg max-w-3xl mx-auto mb-10 sm:mb-12">
          Swachh Kendram leverages real-time data, automation, and community
          engagement to build efficient, eco-friendly waste management systems
          that serve both citizens and municipalities.
        </p>

        {/* Slick Slider for Cards */}
        <div className="px-4 sm:px-8">
          <Slider
            dots={true}
            infinite={true}
            speed={500}
            slidesToShow={4}
            slidesToScroll={1}
            autoplay={true}
            autoplaySpeed={2000}
            initialSlide={0}
            className="custom-dots-slider" // Add this className
            responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ]}
          >
            {[
              {
                icon: <FaMapMarkedAlt className="text-[#00D084] text-6xl" />,
                title: "Geo-Tracking Vehicles",
                desc: "Monitor garbage trucks in real-time with GPS integration to ensure optimized routes and timely waste collection.",
              },
              {
                icon: <FaRecycle className="text-[#00D084] text-6xl" />,
                title: "Smart Segregation",
                desc: "Encourage and monitor effective waste segregation at source for better recycling and reduced landfill pressure.",
              },
              {
                icon: <FaUsersCog className="text-[#00D084] text-7xl" />,
                title: "Grievance Redressal",
                desc: "A responsive system for citizens to report waste-related issues and get timely updates and resolutions.",
              },
              {
                icon: <FaChartBar className="text-[#00D084] text-6xl" />,
                title: "Data-Driven Insights",
                desc: "Use analytics and dashboards to assess collection efficiency, waste volume, zone performance, and more.",
              },
              // Add more cards if needed
              {
                icon: <FaRoute className="text-[#00D084] text-8xl" />,
                title: "Route Optimization",
                desc: "AI-powered route planning for maximum collection efficiency.",
              },
            ].map((card, idx) => (
              <div key={idx} className="px-2">
                <div className="bg-gray-50 rounded-xl p-6 shadow hover:shadow-md transition flex flex-col justify-between h-[350px]">
                  <div className="bg-white p-4 rounded-xl w-fit mx-auto mb-4">
                    {card.icon}
                  </div>
                  <h4 className="text-lg sm:text-xl font-semibold mb-2">
                    {card.title}
                  </h4>
                  <p className="text-black text-md mb-4">{card.desc}</p>
                  <button
                    onClick={() =>
                      navigate(routePaths[idx % routePaths.length])
                    }
                    className="bg-[#00D084] hover:bg-green-600 text-white font-semibold px-6 w-fit py-2 rounded-full mt-auto mx-auto"
                  >
                    Learn More
                  </button>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/* Blogs */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white font-poppins text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-[#00D084] mb-4">
          Our Blogs
        </h2>
        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
          Insights Driving{" "}
          <span className="text-black font-extrabold">
            Smart Waste Management
          </span>
        </h3>
        <p className="text-black text-base sm:text-lg max-w-3xl mx-auto mb-10">
          Explore the latest trends, innovations, and success stories in waste
          technology. Swachh Ajeevi brings you powerful content to stay informed
          and inspired in building cleaner, smarter cities.
        </p>

        <Slider {...settings}>
          {blogPosts.map((post, idx) => (
            <div key={idx} className="px-2">
              <Link to={`/blog/${slugify(post.title)}`}>
                <div className="bg-gray-100 rounded-2xl shadow p-4 h-[520px] flex flex-col hover:shadow-lg transition duration-300">
                  <div className="relative mb-4 rounded-xl overflow-hidden">
                    <img
                      src={post.img}
                      alt={post.title}
                      className="w-full h-56 object-cover"
                    />
                    <span className="absolute bottom-2 left-2 bg-[#00D084] text-white px-3 py-2 text-md font-semibold rounded-full">
                      {post.tag}
                    </span>
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">
                    {post.title}
                  </h4>
                  <p className="text-gray-700 text-md mb-4 text-justify">
                    {truncateWords(post.desc, 35)}
                    {/* {post.desc} */}
                  </p>
                  <div className="flex items-center mt-auto">
                    <img
                      src={post.authorImg}
                      alt={post.author}
                      className="w-10 h-10 rounded-full mr-3"
                    />
                    <div className="text-left">
                      <p className="text-sm font-semibold text-gray-900">
                        {post.author}
                      </p>
                      <p className="text-sm text-gray-500">{post.date}</p>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Slider>
      </div>

      {/* FAQ */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-14 bg-white text-center font-poppins">
        <h3 className="text-[#00D084] text-[22px] font-bold mb-2">FAQs</h3>
        <h2 className="text-3xl sm:text-5xl font-extrabold text-black mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-black text-base sm:text-lg max-w-3xl mx-auto mb-12">
          Here are answers to common questions related to our Smart Waste
          Management systems, citizen participation, and how you can make a
          difference in keeping your city clean and efficient.
        </p>

        <div className="flex flex-col lg:flex-row items-start gap-8">
          {/* FAQ Accordion */}
          <div className="w-full lg:w-1/2 text-left bg-gray-50 rounded-xl">
            <details className="border rounded-md overflow-hidden">
              <summary className="bg-green-100 px-4 py-3 font-medium text-gray-900 cursor-pointer">
                What is Smart Waste Management?
              </summary>
              <div className="px-4 py-3 text-gray-700 text-sm sm:text-base">
                Smart Waste Management uses technology like IoT, GPS tracking,
                and data analytics to monitor waste collection, improve
                efficiency, and keep urban environments cleaner.
              </div>
            </details>
            <details className="border rounded-md overflow-hidden">
              <summary className="bg-white px-4 py-3 font-medium text-gray-900 cursor-pointer">
                How can I report a missed garbage pickup?
              </summary>
              <div className="px-4 py-3 text-gray-700 text-sm sm:text-base">
                You can raise a complaint via the official mobile app or through
                our website by selecting the "Missed Pickup" option. Your report
                will be tracked and assigned to the respective zonal team.
              </div>
            </details>
            <details className="border rounded-md overflow-hidden">
              <summary className="bg-white px-4 py-3 font-medium text-gray-900 cursor-pointer">
                Are the sanitation workers tracked in real-time?
              </summary>
              <div className="px-4 py-3 text-gray-700 text-sm sm:text-base">
                Yes, workers use GPS-enabled mobile attendance and tracking
                systems that help monitor route completion and ensure
                accountability.
              </div>
            </details>
            <details className="border rounded-md overflow-hidden">
              <summary className="bg-white px-4 py-3 font-medium text-gray-900 cursor-pointer">
                What are smart bins and how do they work?
              </summary>
              <div className="px-4 py-3 text-gray-700 text-sm sm:text-base">
                Smart bins are equipped with fill-level sensors that notify the
                control room when they are full, enabling optimized collection
                routes and preventing overflows.
              </div>
            </details>
            <details className="border rounded-md overflow-hidden">
              <summary className="bg-white px-4 py-3 font-medium text-gray-900 cursor-pointer">
                Is my data safe when I use the waste complaint app?
              </summary>
              <div className="px-4 py-3 text-gray-700 text-sm sm:text-base">
                Absolutely. We follow strict data privacy protocols. Your
                personal information is never shared without consent and is only
                used for resolving the complaint efficiently.
              </div>
            </details>
            <details className="border rounded-md overflow-hidden">
              <summary className="bg-white px-4 py-3 font-medium text-gray-900 cursor-pointer">
                How can I volunteer or participate in cleanliness drives?
              </summary>
              <div className="px-4 py-3 text-gray-700 text-sm sm:text-base">
                We love community involvement! You can sign up through our
                portal’s “Get Involved” section or follow our social media for
                announcements on upcoming events.
              </div>
            </details>
          </div>

          {/* FAQ Illustration */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <img
              src={faq} // Replace this with the correct path
              alt="FAQ Bins Illustration"
              className="h-40 sm:h-52 md:h-64 lg:h-80 xl:h-96 object-contain"
            />
          </div>
        </div>
      </div>

      {/* Meet Our Founder */}
      <div className="w-full bg-white pb-8 px-4 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mx-auto mb-16" data-aos="fade-up">
            <h1 className="text-5xl font-bold text-gray-800 mb-6">
              Meet Our Founder & Director
            </h1>
            <p className="text-black max-w-3xl mx-auto text-lg">
              Get to know the minds guiding our vision—a team of seasoned
              professionals dedicated to driving sustainable smart city
              solutions and impactful innovations in waste management.
            </p>
          </div>

          <div
            className="flex justify-center flex-wrap gap-12"
            data-aos="fade-up"
          >
            {/* Adviser Card */}
            <div className="w-full max-w-sm bg-gray-100 shadow-xl rounded-2xl overflow-hidden text-center group transition-all duration-300 hover:shadow-2xl">
              <div className="flex justify-center mt-5">
                <div className="p-2 rounded-full border-4 border-dotted border-[#00D084]">
                  <img
                    src={vishal}
                    alt="Vishal Gupta"
                    className="w-80 h-80 object-cover rounded-full transform group-hover:scale-105 transition duration-300"
                  />
                </div>
              </div>

              <div className="py-6 px-6">
                <h4 className="text-2xl font-bold text-gray-800 mb-2">
                  Vishal Gupta
                </h4>
                <p className="text-gray-500 text-base mb-4">
                  Founder & Director
                </p>

                <div className="flex justify-center space-x-4 mt-4">
                  <a
                    href="https://x.com/vgajeevi?s=11"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 flex items-center justify-center bg-[#00D084] text-white rounded-full hover:bg-green-700 text-lg"
                  >
                    <FaXTwitter />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/vgajeevi/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 flex items-center justify-center bg-[#00D084] text-white rounded-full hover:bg-green-700 text-lg"
                  >
                    <FaLinkedinIn />
                  </a>
                  <a
                    href="https://www.instagram.com/vgajeevi?igsh=cjF3MXQ3N2NrYjYx"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 flex items-center justify-center bg-[#00D084] text-white rounded-full hover:bg-green-700 text-lg"
                  >
                    <FaInstagram />
                  </a>
                </div>
              </div>
            </div>

            {/* Add more adviser cards here if needed */}
          </div>
        </div>
      </div>
    </>
  );
}
